/**
 * Normalizes cached suggested-prompt answers for admin display.
 * Cache may store plain markdown, JSON content parts, or legacy stringified parts.
 */
function extractPartText(part: unknown): string {
  if (part == null) return '';
  if (typeof part === 'string') return part;
  if (typeof part === 'object') {
    const p = part as Record<string, unknown>;
    if (typeof p.text === 'string') return p.text;
  }
  return '';
}

function parseLegacyContentPartsString(raw: string): string | null {
  // e.g. [{type=text, text=Hello **world** <ProductDiscovery />}]
  const matches = [...raw.matchAll(/\{type=text,\s*text=([\s\S]*?)\}(?=\s*[,}\]])/gi)];
  if (matches.length === 0) return null;
  return matches.map((m) => m[1].trim()).join('\n\n');
}

export function formatCachedSuggestedPromptAnswer(raw: string | null | undefined): string {
  if (raw == null) return '';
  const trimmed = String(raw).trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed) as unknown;
      if (Array.isArray(parsed)) {
        const text = parsed.map((part) => extractPartText(part)).filter(Boolean).join('');
        if (text) return text;
      }
    } catch {
      // fall through
    }
    const legacy = parseLegacyContentPartsString(trimmed);
    if (legacy) return legacy;
  }

  if (trimmed.startsWith('{')) {
    try {
      const parsed = JSON.parse(trimmed) as unknown;
      const text = extractPartText(parsed);
      if (text) return text;
    } catch {
      // fall through
    }
  }

  return trimmed;
}
